import {
    userSetFilter,
    userClearFilterCriteria,
    userApplyFilterCriteria
} from "../../../actions/user-actions"

import buildFilterWidgetContainer from "../../common/build-filter-widget-container"

import UserFilterFormContainer from "./UserFilterFormContainer"

export default buildFilterWidgetContainer(
    UserFilterFormContainer,
    userClearFilterCriteria,
    userApplyFilterCriteria,
    userSetFilter
)
